import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
import Vue from "vue";

function initialState() {
  return {};
}

const state = initialState();

const actions = {
  fetchAccounts: function(context, request) {
    return Vue.http
      .get("platform/searchdealers?" + request)
      .then(function(data) {
        return data && data.data ? data.data.Data : [];
      });
  },
  fetchPlatforms: function(context, accountId) {
    return Vue.http
      .get("account/allplatforms/" + accountId)
      .then(function(data) {
        return data && data.data ? data.data.Data : [];
      });
  },
  getBasePackages: function() {
    return Vue.http.get("packages/GetPackages").then(response => {
      let data = [];
      if (response && response.data && response.data.Data) {
        data = response.data.Data;
        data = data.filter(x => !x.IsMasterPackage);
        return data.sort(HelperFunctions.sortByPropertyAsc("DisplayOrder"));
      }
      return data;
    });
  },
  getDealerChangeLogs: function(context, request) {
    return Vue.http
      .post(`/packages/GetDealerPackageChangeLogs`, request)
      .then(function(data) {
        return data.data;
      });
  },
  getDealerPackageCofig: function(context, request) {
    return Vue.http
      .post(`/packages/GetDealerPackage`, request.dealerPackage)
      .then(response => {
        return response && response.data ? response.data : [];
      });
  },
  saveDealerPackageConfig: function(context, packageDetails) {
    return Vue.http
      .post(`/packages/SaveDealerPackage`, packageDetails);
  }
};

const mutations = {};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/PackageConfigSettings.js